export const ServiceType = {
    Real: 1,
    Theoretical: 2
};



// WEBPACK FOOTER //
// ./src/enuns/AfterSales/serviceArea.enum.js